import React from "react";

import { observer } from "mobx-react";

import { useStores } from "../../../../contexts/StoreContext";
import CustomSelect from "../../../CustomSelect/CustomSelect";
import Loader from "../../Loader/Loader";

const filterMap = {
  FULL_TIME: "Full Time",
  PART_TIME: "Part Time",
};

function RolesFilter({
  isLoading,
  type = "categories",
  label,
  className,
  borderRadius = "10px",
}) {
  const { filtersStore } = useStores();

  const { applyFilters, setFromFilter, searchBuckets, frontendFilters } =
    filtersStore;

  const vacancyCount =
    searchBuckets.category?.reduce((acc, { name, count }) => {
      acc[name] = count;
      return acc;
    }, {}) || {};

  const handleChange = (vacancyCategories) => {
    const cats = vacancyCategories.map((x) => x.value);
    setFromFilter("categories", cats);
    applyFilters();
  };

  if (isLoading) {
    return <Loader />;
  }

  const roleSelectStyles = {
    container: (provided) => {
      return {
        ...provided,
        height: "100%",
        width: "100%",
      };
    },
    control: (provided) => ({
      ...provided,
      background: "white",
      borderRadius,
      boxShadow: "none",
      fontWeight: "400",
      height: "100%",
      textColor: "black",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: "0",
      color: "black",
    }),
    option: (provided) => ({
      ...provided,
      color: "black",
      height: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
  };

  const defaultFilters = frontendFilters[type]?.map((a) => {
    return { label: filterMap[a] || a, value: a };
  });

  return (
    <CustomSelect
      styles={roleSelectStyles}
      value={defaultFilters || undefined}
      id="role"
      isMulti
      className={className}
      onChange={(e) => {
        handleChange(e);
      }}
      options={Object.keys(vacancyCount)?.map((a) => {
        return { label: filterMap[a] || a, value: a };
      })}
      placeholder={label}
      aria-label={label}
      aria-labelledby={label ? `${label}-label` : undefined}
    />
  );
}
export default observer(RolesFilter);
